// import React, { Fragment, useState, useRef } from 'react'
// import { Dialog, Transition } from '@headlessui/react'
// import { Formik } from 'formik'

// export default function Modal ( { title, displayModal = null , handleDisplayModal, handleFormSubmit, children } ) {
//     // const [ open, setOpen ] = useState( null )

//     const handleDisplay =  () => {
//         handleDisplayModal( !displayModal )
//     }

//     const cancelButtonRef = useRef( null )

//     const handleSubmit = async () => {
//       await handleFormSubmit()
//       // await handleDisplay()
//     }

//     return (
//     <Transition.Root show={displayModal} as={Fragment}>
//       <Dialog
//         as="div"
//         className="fixed z-10 inset-0 overflow-y-auto"
//         initialFocus={cancelButtonRef}
//         onClose={handleDisplay}>
//         <div
//           className="flex items-end justify-center min-h-screen w-3/4 pt-4 px-4 pb-20 text-center sm:block
//           sm:p-0">
//           <Transition.Child
//             as={Fragment}
//             enter="ease-out duration-300"
//             enterFrom="opacity-0"
//             enterTo="opacity-100"
//             leave="ease-in duration-200"
//             leaveFrom="opacity-100"
//             leaveTo="opacity-0">
//             <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
//           </Transition.Child>

//           {/* This element is to trick the browser into centering the modal contents. */}
//           <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
//             &#8203;
//           </span>
//           <Transition.Child
//             as={Fragment}
//             enter="ease-out duration-300"
//             enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
//             enterTo="opacity-100 translate-y-0 sm:scale-100"
//             leave="ease-in duration-200"
//             leaveFrom="opacity-100 translate-y-0 sm:scale-100"
//             leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
//             <div
//               className="inline-block align-bottom bg-white rounded-md
//                 text-left 
//                 overflow-hidden shadow-xl 
//                 transform transition-all 
//                 sm:align-middle w-4/5">
//               <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
//                 <div className="w-full">
//                   <>
//                   {children}
//                   </>
//                 </div>
//               </div>
              
//             </div>
//           </Transition.Child>
//         </div>
//       </Dialog>
//     </Transition.Root>
//     )
// }
export default function( { children } ) {
  return (
      <div className="relative z-50 w-4/5">
          <div className="fixed inset-0 bg-black/10" aria-hidden="true"/>

          <div className="fixed inset-0 flex items-center justify-center p-4">
              <div className="flex min-h-full items-center justify-center">
                  {children}
              </div>
          </div>
      </div>
  )
}